/* tslint:disable */
import { Injectable } from '@angular/core';
import { Environment, EnvironmentService } from '@galaxy/core';

@Injectable()
export class HostService {
  private _host: string;
  private _httpsHost: string;

  constructor(private environmentService: EnvironmentService) {}

  host(): string {
    if (this._host) {
      return this._host;
    }

    switch (this.environmentService.getEnvironment()) {
      case Environment.LOCAL:
        this._host = 'multi-location-analytics-api.vendasta-local.com';
        break;
      case Environment.TEST:
        this._host = 'multi-location-analytics-api-test.apigateway.co';
        break;
      case Environment.DEMO:
        this._host = 'multi-location-analytics-api-demo.apigateway.co';
        break;
      case Environment.PROD:
        this._host = 'multi-location-analytics-api-prod.apigateway.co';
        break;
    }
    return this._host;
  }

  httpsHost(): string {
    if (this._httpsHost) {
      return this._httpsHost;
    }

    switch (this.environmentService.getEnvironment()) {
      case Environment.LOCAL:
        this._httpsHost = 'multi-location-analytics.vendasta-local.com';
        break;
      case Environment.TEST:
        this._httpsHost = 'multi-location-analytics-test.apigateway.co';
        break;
      case Environment.DEMO:
        this._httpsHost = 'multi-location-analytics-demo.apigateway.co';
        break;
      case Environment.PROD:
        this._httpsHost = 'multi-location-analytics-prod.apigateway.co';
        break;
    }
    return this._httpsHost;
  }

  hostWithScheme(): string {
    const scheme = this.environmentService.getEnvironment() === Environment.LOCAL ? 'http://' : 'https://';
    return scheme + this.host();
  }

  httpsHostWithScheme(): string {
    const scheme = this.environmentService.getEnvironment() === Environment.LOCAL ? 'http://' : 'https://';
    return scheme + this.httpsHost();
  }
}
